module.exports = __webpack_public_path__ + "media/images/ir/common/arrow_select-095c7f2a7b208c1d1ade121f4b5976dc.svg";